import { render, staticRenderFns } from "./FinalBootcamp.vue?vue&type=template&id=5bca1a3e&scoped=true&"
import script from "./FinalBootcamp.vue?vue&type=script&lang=js&"
export * from "./FinalBootcamp.vue?vue&type=script&lang=js&"
import style0 from "./FinalBootcamp.vue?vue&type=style&index=0&id=5bca1a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca1a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VCard,VChip,VCol,VIcon,VRow})
